import { LevelDiscount } from "@/screens/rewards/components/LevelDiscount"

export const AllRewards = () => (
  <>
    <LevelDiscount level={"bronze"} />
    <LevelDiscount level={"silver"} />
    <LevelDiscount level={"gold"} />
    <LevelDiscount level={"platinum"} />
    <LevelDiscount level={"diamond"} />
  </>
)
